import { StoreState } from "..";

export const getVisible = (state: StoreState) => state.loadingScreen.visible;
